// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailedAnimation_container__1fgW0","content":"DetailedAnimation_content__3QLpg","animation":"DetailedAnimation_animation__F-SiR"};